import React, { useState, useRef } from "react";
import { EllipsisOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import images from "../../themes/appImage";
import { imageURL } from "../../redux/Api/apikit";
import { Popover, Button, Modal } from "antd";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import {
  addUserinCircleLoad,
  deleteCircleLoad,
  editCircleLoad,
} from "../../redux/slices/inner.slice";
import { useFormik } from "formik";
import appconstant from "../../themes/appconstant";
import { getFileType } from "../../utils/global-func";

const InnerCard = ({ name, dec, memberUserList, id, myid }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [modal1Open, setModal1Open] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [descriptionLength, setDescriptionLength] = useState(0);
  const fileInputRef = useRef(null);

  // Function to handle navigation to inner circle details
  const handleClick = () => {
    navigate("/innercircletabs", {
      state: {
        id: id,
        myid: myid,
      },
    });
  };

  const closePopover = () => {
    setOpen(false);
  };

  // Calculate remaining images count for display
  const remainingImagesCount =
    memberUserList?.length > 3 ? memberUserList?.length - 3 : 0;

  // Content of the popover
  const content = (
    <div className="flex flex-col">
      <Button type="text" onClick={() => handleAddUsers(id)}>
        Add Users
      </Button>
      <Button type="text" onClick={() => handleEdit(id)}>
        Edit
      </Button>
      <Button type="text" onClick={() => handleRemove(id)}>
        Remove
      </Button>
    </div>
  );

  // Placeholder functions for edit and delete actions
  const handleEdit = (id) => {
    setModal1Open(true);
    closePopover();
  };

  const handleRemove = (id) => {
    console.log(`Delete clicked for item ${id}`);
    const data = {
      circle: id,
    };
    dispatch(deleteCircleLoad(data));
    closePopover();
  };

  const handleAddUsers = (id) => {
    setModalOpen(true);
    closePopover();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("csv", file);
      formData.append("type", getFileType(file.type));
      formData.append("circle", id);
      formData.append("organisation", myid);
      dispatch(addUserinCircleLoad(formData));
      setModalOpen(false);
    }
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const initialValues = {
    name: name,
    description: dec,
    circle: id,
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required("Please enter name")
      .min(3, "Name must be at least 3 characters")
      .max(15, "Name must be at most 15 characters"),
    description: Yup.string()
      .required("Please enter description")
      .min(10, "Description must be at least 10 characters")
      .max(500, "Description must be at most 500 characters"),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      dispatch(editCircleLoad(values));
      setModal1Open(false);
    },
  });

  const handleDescriptionChange = (event) => {
    formik.handleChange(event); // Formik's handleChange to update form state
    const { value } = event.target;
    setDescriptionLength(value.length); // Update character count dynamically
  };

  return (
    <div className="border rounded-[10px] shadow-card-shadow bg-white">
      <div className="flex flex-col">
        <div className="p-4 flex flex-col justify-between gap-6">
          <div>
            <div className="flex justify-between items-center new-popup">
              <div className="text-base font-bold text-dark">{`${name.slice(
                0,
                12
              )}...`}</div>
              <Popover
                content={content}
                trigger="click"
                open={open}
                onOpenChange={handleOpenChange}
              >
                <div>
                  <EllipsisOutlined />
                </div>
              </Popover>
            </div>
            <div className="flex items-center gap-1">
              <div>
                <img src={images.redDot} alt="live-img" />
              </div>
              <div className="text-[10px] font-normal text-neutraldark">{`${dec.slice(
                0,
                10
              )}...`}</div>
            </div>
          </div>
          <div className="flex justify-between">
            <div className="flex">
              {memberUserList?.length > 0 &&
                memberUserList.slice(0, 3).map((user, index) =>
                  user?.user?.avatar?.length > 0 ? (
                    <img
                      key={index}
                      src={`${imageURL}${user?.user?.avatar}`}
                      alt={`avatar-${index}`}
                      style={{
                        objectFit: "contain",
                        width: "26px",
                        height: "26px",
                      }}
                    />
                  ) : null
                )}
              {remainingImagesCount > 0 && (
                <div className="flex items-center justify-center bg-white text-dark border border-royalPurple w-[26px] h-[26px] font-xs p-4 rounded-full">
                  +{remainingImagesCount}
                </div>
              )}
            </div>
            <div onClick={handleClick}>
              <img src={images.ArrowRight} alt="arrow-right" />
            </div>
          </div>
        </div>
      </div>

      <Modal
        title=""
        className="modal-update"
        centered
        open={modal1Open}
        onCancel={() => {
          setModal1Open(false);
        }}
        footer={null}
        width={600}
      >
        <div className="add-user-popup">
          <div className="modal-add-user">
            <h1>Edit Inner Circle</h1>
          </div>
          <div className="description-inner-circle">
            <form onSubmit={formik.handleSubmit}>
              <div className="wrapper_line">
                <div className="form-group">
                  <label htmlFor="name">{appconstant.name}</label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    placeholder="Enter Inner circle name"
                    className={`form-control ${
                      formik.touched.name && formik.errors.name
                        ? "is-invalid"
                        : ""
                    }`}
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.name && formik.errors.name ? (
                    <div className="text-red-500 text-xs mt-1">
                      {formik.errors.name}
                    </div>
                  ) : null}
                </div>
                <div className="form-group">
                  <div className="textarea-label">
                    <label htmlFor="description">
                      {appconstant.description}
                    </label>
                    <p className="text-xs text-gray-400">
                      {descriptionLength}/500
                    </p>
                  </div>
                  <textarea
                    id="description"
                    name="description"
                    rows="5"
                    cols="50"
                    className={`form-control-textarea ${
                      formik.touched.description && formik.errors.description
                        ? "is-invalid"
                        : ""
                    }`}
                    placeholder="Enter Description"
                    value={formik.values.description}
                    onChange={handleDescriptionChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.description && formik.errors.description ? (
                    <div className="text-red-500 text-xs">
                      {formik.errors.description}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="click-to-upload">
                <div className="create-inner-circle-btn">
                  <button type="submit">Create Inner Circle</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Modal>

      <Modal
        title=""
        className="modal-update"
        centered
        visible={modalOpen}
        onCancel={handleModalClose}
        footer={null}
        width={600}
      >
        <div className="add-user-popup">
          <div className="modal-add-user">
            <h1>Import People to your Circle</h1>
            <div className="user-disp">
              <p>You can always Invite more People later!</p>
            </div>
          </div>
          <div className="click-to-upload">
            <div className="upload-file">
              <img src={images.fileImg} alt="back" />
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                accept=".csv,.xls, application/vnd.ms-excel"
                onChange={handleFileChange}
              />
              <div>
                <button onClick={() => fileInputRef.current.click()}>
                  Click here to upload
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default InnerCard;
